/**
 * Custom language detector for widget and standalone app
 *
 * Widget mode: Reads from data-language attribute on script tag
 * Standalone mode: Extracts from domain (spa.syndeo.uk -> en, spa.syndeo.rs -> sr)
 */

export const detectLanguage = (): string => {
  // Check if we're in widget mode (script tag exists)
  const scriptTag = document.currentScript as HTMLScriptElement ||
                    document.querySelector('script[data-api-key]') as HTMLScriptElement;

  if (scriptTag) {
    // Widget mode: check data-language attribute
    const dataLanguage = scriptTag.getAttribute('data-language');
    if (dataLanguage) {
      return dataLanguage;
    }
  }

  // Standalone mode: extract from domain
  const domain = window.location.hostname;

  // Map domain extensions to languages
  const domainLanguageMap: { [key: string]: string } = {
    'uk': 'en',
    'rs': 'sr',
    'local': 'sr',  // For local testing (aws.syndeo.local)
    'com': 'en',
    // Add more as new markets are added
    // 'de': 'de',
    // 'fr': 'fr',
  };

  // Extract TLD (last part after the last dot)
  const tld = domain.split('.').pop();

  if (tld && domainLanguageMap[tld]) {
    return domainLanguageMap[tld];
  }

  // Fallback to browser language
  const browserLang = navigator.language.split('-')[0]; // 'en-US' -> 'en'

  // Only return browser language if we support it
  const supportedLanguages = ['en', 'sr'];
  if (supportedLanguages.includes(browserLang)) {
    return browserLang;
  }

  // Final fallback to English
  return 'en';
};

export default detectLanguage;
